<template>
  <div id="terms_of_service">
    <TerrorZoneNavBar />
    <div class="tos-content">
      <h1>Terms of Service</h1>
      <p>Welcome to our service! These Terms of Service (hereinafter referred to as "Terms") govern your access to and use of the D2R Terror Zones related information services. Please read these Terms carefully before using our website and 3rd parties Apps (for example, Discord) (hereinafter referred to as "the Web Apps").</p>
      
      <h2>1. Services Provided</h2>
      <p>We specialize in providing information related to Terror Zones in D2R, including but not limited to the latest updates, zone maps, spawn times, and more.</p>
      
      <h2>2. Prohibited Actions</h2>
      <p>To ensure the quality of our services and protect our legal rights, you must comply with the following rules when using our services:</p>
      <ul>
          <li><strong>No Web Crawling or Scraping:</strong> The use of any automated programs (including but not limited to crawlers, bots, scripts, etc.) to access, scrape, or store content from our Web Apps are strictly prohibited without our explicit written permission.</li>
          <li><strong>No Unauthorized Data Usage:</strong> You may not use any data or information from this Web Apps to create, develop, or promote any competing websites, applications, or similar services.</li>
          <li><strong>No Malicious Activities:</strong> You may not engage in any activity that could disrupt the normal operation of this Website, including but not limited to excessive requests, malicious attacks, or attempts to bypass security measures.</li>
      </ul>
      
      <h2>3. Consequences of Violations</h2>
      <p>If we detect any violations of the above restrictions, we reserve the right to take the following actions, including but not limited to:</p>
      <ul>
          <li>Immediately blocking the violator’s IP address;</li>
          <li>Canceling or restricting their access rights;</li>
          <li>Taking further legal action to protect our legitimate interests.</li>
      </ul>
      
      <h2>4. Disclaimers</h2>
      <ul>
          <li>We strive to ensure the accuracy of the information provided, but we do not guarantee its completeness, accuracy, or applicability. We are not responsible for any loss resulting from the use of this Web Apps’ information.</li>
          <li>The content provided on this Web Apps are for reference only and does not constitute official game information or business advice.</li>
          <li>We reserve the right to modify, suspend, or terminate part or all of the services at any time without prior notice.</li>
      </ul>
      
      <h2>5. Changes to Terms of Service</h2>
      <p>We may periodically update these Terms of Service to reflect changes in our services or legal requirements. The latest version of the Terms will always be posted on our Website and will take effect immediately. Please check regularly to stay informed about the latest Terms.</p>
      
      <h2>7. Contact Information</h2>
      <p>If you have any questions regarding these Terms of Service, please contact us at support@d2tz.info</p>
    </div>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'

export default {
  name: 'TermsOfService',

  components: {
    TerrorZoneNavBar,
    TerrorZoneFooter,
  },
}
</script>

<style scoped>
.tos-content {
  color: #fff;
  justify-content: space-around;
  max-width: 900px;
  margin: 40px auto;
  width: 70%;
}
@media (max-width: 600px) {
  .tos-content {
    width: 90%;
  }
}
</style>
